/**
 * Body for POST /api/payfast?action=generate.
 *
 * PAYG names an immutable server-side pack and never sends an amount: the server
 * prices the pack, applies any coupon and credits the full pack. Gift cards keep
 * their amount (the server validates it against the allowed denominations).
 */
export type GenerateBody =
  | { pack: string; plan: 'payg'; discountCode?: string }
  | { amount: number; plan: string };

export function buildGenerateBody(
  plan: string,
  amount: number,
  discountCode?: string,
): GenerateBody {
  if (plan === 'payg') {
    const body: { pack: string; plan: 'payg'; discountCode?: string } = {
      pack: `payg_r${amount}`,
      plan: 'payg',
    };
    if (discountCode) body.discountCode = discountCode;
    return body;
  }
  return { amount, plan };
}
